import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Card, Col, Form, Row, Steps } from 'antd';
import { AppWrappperHOC } from '../Root/HOC';
import Container from '../../components/Container';
import { ZaggleCard } from '../NetworkCards/StyledNetworkCard';
import { constants, utils } from '../../devUtils';
import { StyledIndusindMinKyc } from './StyledIndusIndMinkyc';
import PersonalAddressForm from './PersonalAddressForm';
import ResidentialAddressForm from './ResidentialAddressForm';
import WorkAddressForm from './WorkAddressForm';
import { IndusindMinKycDispatchToProps, IndusindMinKycProps, IndusindMinKycmapStateToProps } from './IndusindMinKycDataHandler';

const { Step } = Steps;

class IndusindMinKyc extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      checkboxValue: false,
      formValues: {
        personalDetails: {},
        residentialAddressDetails: {},
        workAddressDetails: {},
      },
      residentialAddressValues: {},
      preferredAddressValues: {},
      workAddressValues: {},
    };
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
  }

  componentDidMount() {
    const { onInitIndusindMinKycUserInfo } = this.props;
    onInitIndusindMinKycUserInfo();
  }

  componentWillReceiveProps(nextProps) {
    const {
      IndusindMinKycUserInfo: _IndusindMinKycUserInfo,
      IndusindMinKycUserUpdateSuccess: _IndusindMinKycUserUpdateSuccess,
    } = this.props;
    const {
      history,
      IndusindMinKycUserInfo,
      IndusindMinKycUserInfo: {
        data: {
          client_kyc_upload = {},
        } = {},
        status = false,
      } = {},
      IndusindMinKycUserUpdateSuccess, IndusindMinKycUserUpdateSuccess: { status: updateStatus },
      onInitUpdatedUserProfile,
    } = nextProps;
    if (!utils.isEqual(IndusindMinKycUserUpdateSuccess, _IndusindMinKycUserUpdateSuccess) && updateStatus) {
      utils.forceRedirect(history, { pathname: constants.LINK_PAY_BALANCE });
      onInitUpdatedUserProfile();
    } else if (!utils.isEqual(IndusindMinKycUserInfo, _IndusindMinKycUserInfo) && status) {
      this.setState({ formValues:
        {
          personalDetails: client_kyc_upload || {},
          residentialAddressDetails: client_kyc_upload || {},
          workAddressDetails: client_kyc_upload || {},
        },
      });
      this.setFormValues(nextProps);
    }
    return '';
  }

  componentWillUnmount() {
    const { onResetIndusindMinKycUserInfo } = this.props;
    onResetIndusindMinKycUserInfo({});
  }

  setFormValues(nextProps) {
    const {
      IndusindMinKycUserInfo: {
        data: {
          client_kyc_upload = {},
        } = {},
      } = {},
    } = nextProps;
    if (client_kyc_upload && client_kyc_upload.residential_address) {
      this.setState({
        residentialAddressValues: client_kyc_upload.residential_address,
      });
    }
    if (client_kyc_upload && client_kyc_upload.preferred_address) {
      this.setState({
        preferredAddressValues: client_kyc_upload.preferred_address,
      });
    }
    if (client_kyc_upload && client_kyc_upload.work_address) {
      this.setState({
        workAddressValues: client_kyc_upload.work_address,
      });
    }
  }

  next(currentStep, values, preferredAddressChecked = false) {
    const {
      residential_address_1 = '',
      residential_address_2 = '',
      residential_address_3 = '',
      residential_city = '',
      residential_state = '',
      residential_pincode = '',
      preferred_address_1 = '',
      preferred_address_2 = '',
      preferred_address_3 = '',
      preferred_city = '',
      preferred_state = '',
      preferred_pincode = '',
    } = values;
    switch (currentStep) {
      case 0:
        this.setState((prevState) => ({
          current: 1,
          formValues: {
            ...prevState.formValues,
            personalDetails: values,
          },
        }));
        break;
      case 1:
        this.setState((prevState) => ({
          ...prevState.checkboxValue,
          checkboxValue: preferredAddressChecked,
        }));
        this.setState((prevState) => ({
          current: 2,
          ...prevState.formValues,
          ...prevState.residentialAddressValues,
          ...prevState.preferredAddressValues,
          residentialAddressValues: {
            address_line1: residential_address_1,
            address_line2: residential_address_2,
            address_line3: residential_address_3,
            city_id: residential_city,
            state_id: residential_state,
            pincode: residential_pincode,
          },
          preferredAddressValues: {
            address_line1: preferred_address_1,
            address_line2: preferred_address_2,
            address_line3: preferred_address_3,
            city_id: preferred_city,
            state_id: preferred_state,
            pincode: preferred_pincode,
          },
        }));
        break;
      default:
        this.setState({ current: 0 });
        break;
    }
  }

  prev(currentStep, values, preferredAddressChecked = false) {
    const {
      residential_address_1 = '',
      residential_address_2 = '',
      residential_address_3 = '',
      residential_city = '',
      residential_state = '',
      residential_pincode = '',
      preferred_address_1 = '',
      preferred_address_2 = '',
      preferred_address_3 = '',
      preferred_city = '',
      preferred_state = '',
      preferred_pincode = '',
      work_address_1 = '',
      work_address_2 = '',
      work_address_3 = '',
      work_state = '',
      work_city = '',
      work_pincode = '',
    } = values;
    switch (currentStep) {
      case 1:
        this.setState((prevState) => ({
          ...prevState.checkboxValue,
          checkboxValue: preferredAddressChecked,
        }));
        this.setState((prevState) => ({
          current: 0,
          ...prevState.formValues,
          ...prevState.residentialAddressValues,
          ...prevState.preferredAddressValues,
          residentialAddressValues: {
            address_line1: residential_address_1,
            address_line2: residential_address_2,
            address_line3: residential_address_3,
            city_id: residential_city,
            state_id: residential_state,
            pincode: residential_pincode,
          },
          preferredAddressValues: {
            address_line1: preferred_address_1,
            address_line2: preferred_address_2,
            address_line3: preferred_address_3,
            city_id: preferred_city,
            state_id: preferred_state,
            pincode: preferred_pincode,
          },
        }));
        break;
      case 2:
        this.setState((prevState) => ({
          ...prevState.checkboxValue,
          checkboxValue: preferredAddressChecked,
        }));
        this.setState((prevState) => ({
          current: 1,
          formValues: {
            ...prevState.formValues,
            ...prevState.workAddressValues,
            workAddressValues: {
              address_line1: work_address_1,
              address_line2: work_address_2,
              address_line3: work_address_3,
              state_id: work_state,
              city_id: work_city,
              pincode: work_pincode,
            },
          },
        }));
        break;
      default:
        this.setState({ current: 0 });
        break;
    }
  }

  handleFormSubmit(values) {
    const {
      work_address_1 = '',
      work_address_2 = '',
      work_address_3 = '',
      work_state = '',
      work_city = '',
      work_pincode = '',
    } = values;
    const {
      onInitIndusindMinKycUpdate,
      IndusindMinKycUserInfo: {
        data: {
          country: {
            id = '',
          } = {},
        } = {},
      } = {},
    } = this.props;
    const {
      formValues: {
        personalDetails,
      },
      residentialAddressValues: {
        address_line1: residentialAddressLine1 = '',
        address_line2: residentialAddressLine2 = '',
        address_line3: residentialAddressLine3 = '',
        state_id: residentialAddressStateId = '',
        city_id: residentialAddressCityId = '',
        pincode: residentialAddressPincode = '',
      },
      preferredAddressValues: {
        address_line1: preferredAddressLine1 = '',
        address_line2: preferredAddressLine2 = '',
        address_line3: preferredAddressLine3 = '',
        state_id: preferredAddressStateId = '',
        city_id: preferredAddressCityId = '',
        pincode: preferredAddressPincode = '',
      },
    } = this.state;
    onInitIndusindMinKycUpdate({
      min_kyc: {
        ...personalDetails,
        client_kyc_addresses_attributes: [
          {
            address_type: 'residential_address',
            address_line1: residentialAddressLine1,
            address_line2: residentialAddressLine2,
            address_line3: residentialAddressLine3,
            country_id: id,
            state_id: residentialAddressStateId,
            city_id: residentialAddressCityId,
            pincode: residentialAddressPincode,
          },
          {
            address_type: 'preferred_address',
            address_line1: preferredAddressLine1,
            address_line2: preferredAddressLine2,
            address_line3: preferredAddressLine3,
            country_id: id,
            state_id: preferredAddressStateId,
            city_id: preferredAddressCityId,
            pincode: preferredAddressPincode,
          },
          {
            address_type: 'work_address',
            address_line1: work_address_1,
            address_line2: work_address_2,
            address_line3: work_address_3,
            country_id: id,
            state_id: work_state,
            city_id: work_city,
            pincode: work_pincode,
          },
        ],
      },
    });
  }

  render() {
    const {
      current,
      formValues,
      checkboxValue,
      residentialAddressValues,
      preferredAddressValues,
      workAddressValues,
    } = this.state;
    const { onInitIndusindMinKycCities, isLoadingStatus = false } = this.props;
    const steps = [
      {
        title: 'Personal Details',
        content: <PersonalAddressForm
          handleNextStep={(currentStep, values) => this.next(currentStep, values)}
          formValues={formValues}
          onInitIndusindMinKycCities={onInitIndusindMinKycCities}
        />,
      },
      {
        title: 'Residential Address Details',
        content: <ResidentialAddressForm
          handleNextStep={(currentStep, values, preferredAddressChecked) => this.next(currentStep, values, preferredAddressChecked)}
          handlePrevStep={(currentStep, values, preferredAddressChecked) => this.prev(currentStep, values, preferredAddressChecked)}
          formValues={formValues}
          onInitIndusindMinKycCities={onInitIndusindMinKycCities}
          checkboxValue={checkboxValue}
          residentialAddressValues={residentialAddressValues}
          preferredAddressValues={preferredAddressValues}
        />,
      },
      {
        title: 'Work Address Details',
        content: <WorkAddressForm
          handlePrevStep={(currentStep, values, preferredAddressChecked) => this.prev(currentStep, values, preferredAddressChecked)}
          formValues={formValues}
          handleFormSubmit={(values) => this.handleFormSubmit(values)}
          onInitIndusindMinKycCities={onInitIndusindMinKycCities}
          isLoadingStatus={isLoadingStatus}
          checkboxValue={checkboxValue}
          workAddressValues={workAddressValues}
        />,
      },
    ];
    return (
      <StyledIndusindMinKyc>
        <Container>
          <ZaggleCard>
            <Row align="middle" type="flex" gutter={24} className="margin-t-2">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h2>Manage Zaggle Cards</h2>
                <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                  <Breadcrumb.Item href={constants.LINK_MY_PROFILE} className="crumb-link">My Account</Breadcrumb.Item>
                  <Breadcrumb.Item href={constants.LINK_PAY_BALANCE} className="crumb-link">Manage Cards</Breadcrumb.Item>
                  <Breadcrumb.Item>Min Kyc</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded noborder noshadow">
              <Row align="middle" type="flex" gutter={24} justify="center" >
                <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                  <Steps current={current} className="custom-ant-steps ant-steps-label-vertical" progressDot >
                    {steps && steps.length && steps.map(({ title = '' }) => (
                      <Step
                        key={title}
                        title={title}
                      />))}
                  </Steps>
                </Col>
              </Row>
              <Row align="top" type="flex" justify="start" gutter={20}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-3">
                  {steps[current].content}
                </Col>
              </Row>
            </Card>
          </ZaggleCard>
        </Container>
      </StyledIndusindMinKyc>
    );
  }
}

IndusindMinKyc.propTypes = IndusindMinKycProps;

const IndusindMinKycWrapper = Form.create({ name: 'normal_admin' })(IndusindMinKyc);
const component = connect(IndusindMinKycmapStateToProps, IndusindMinKycDispatchToProps)(AppWrappperHOC(IndusindMinKycWrapper));
export { IndusindMinKyc, IndusindMinKycWrapper };
export default component;




// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/index.js